export default __webpack_public_path__ + "static/media/planta-t-2.fe688355.jpg";